import { render } from "./kalio-program-goal-panel.vue?vue&type=template&id=bf85607e"
import script from "./kalio-program-goal-panel.vue?vue&type=script&lang=js"
export * from "./kalio-program-goal-panel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__